
import React, { useState } from "react";
import {
  Box,
  Card,
  Tabs,
  Tab,
} from "@mui/material";

import {
  PeopleAltRounded,
  AccessTimeRounded,
  ScheduleRounded,
} from "@mui/icons-material";

import LateArrivalDashboard from "./LateArrivalDashboard";
import VisitorDashboard from "../VisitorDashboard";
import MissingPunchDashboard from "../missing-punch-dashboard/MissingPunchDashboard";
import TwoMinLateDashboard from "./TwoMinLateDashboard";

const VisitorAttendanceDashboard = () => {
  const [tab, setTab] = useState(0);

  const [mountedTabs, setMountedTabs] = useState({
    0: true,
    1: false,
    2: false,
  });

  const handleTabChange = (_, newValue) => {
    setTab(newValue);

    setMountedTabs((prev) => ({
      ...prev,
      [newValue]: true,
    }));
  };

  return (
    <Box sx={{ width: "100%" }}>
      <Card
        elevation={0}
        sx={{
          border: "1px solid",
          borderColor: "divider",
          borderRadius: 3,
          overflow: "hidden",
        }}
      >
        <Tabs
          value={tab}
          onChange={handleTabChange}
          variant="fullWidth"
          sx={{
            borderBottom: "1px solid",
            borderColor: "divider",

            "& .MuiTab-root": {
              minHeight: 54,
              textTransform: "none",
              fontWeight: 700,
              fontSize: 14,
            },
          }}
        >
          <Tab
            icon={<PeopleAltRounded fontSize="small" />}
            iconPosition="start"
            label="Visitor Pass Dashboard"
          />

          <Tab
            icon={<AccessTimeRounded fontSize="small" />}
            iconPosition="start"
            label="Attendance Dashboard"
          />

          <Tab
            icon={<ScheduleRounded fontSize="small" />}
            iconPosition="start"
            label="2-Minute Late Dashboard"
          />
        </Tabs>

        {/* Visitor Pass Dashboard */}
        <Box hidden={tab !== 0}>
          {mountedTabs[0] && <VisitorDashboard />}
        </Box>

        {/* Attendance Dashboard */}
        <Box hidden={tab !== 1}>
          {mountedTabs[1] && <LateArrivalDashboard />}
        </Box>

        {/* 2-Minute Late Dashboard */}
        <Box hidden={tab !== 2}>
          {mountedTabs[2] && <TwoMinLateDashboard />}
        </Box>
      </Card>
    </Box>
  );
};

export default VisitorAttendanceDashboard;
